export const ModalHeader = "ModalHeader";
export const ModalHeaderTitleContainer = `${ModalHeader}__TitleContainer`;
export const ModalHeaderTabsContainer = `${ModalHeader}__TabsContainer`;
